<nav class="flex flex-row justify-center p-2 w-full gap-3 sm:p-6 sm:gap-4 sm:mb-2">
  <h4><a href="#projects">Projects</a></h4>
  <h4><a href="#sponsors">Supports</a></h4>
  <h4><a href="#about">About</a></h4>
</nav>

<style>
  a {
    @apply no-underline hover:underline
  }
</style>